import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByPropertyPipe',
    pure: false
})
export class FilterByPropertyPipe implements PipeTransform {
    transform<T>(items: T[], filter: string, propertyName: string): T[] {
        if (!items || !filter || !propertyName) {
            return items;
        }

        return items.filter(item => {
            if(item[propertyName]) {
                if(typeof item[propertyName] == 'string')
                    return item[propertyName].toLowerCase().indexOf(filter.toLowerCase()) !== -1;
                else
                    return item[propertyName] === filter;
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/app/pipes/filter-by-property-pipe/filter-by-property.pipe.ts